import * as actionTypes from "./ProjectsTypes";

const INITIAL_STATE = {
    defaultAssigneeList: [],
    projectLeadList: [],
    projectTypeList: [],
    projectStatusList: [],
    userList: [],
    projectDetail: null,
    projectList: [],
    projectFilterList: [],
    newProjectDetails: [],
    basicFilterData: []
};

const SDProjectsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETDEFAULTASSIGNEELIST:
            return {
                ...state,
                defaultAssigneeList: action.payload.list,
            };
        case actionTypes.SETPROJECTLEADLIST:
            return {
                ...state,
                projectLeadList: action.payload.list,
            };
        case actionTypes.SETPROJECTTYPELIST:
            return {
                ...state,
                projectTypeList: action.payload.list,
            };
        case actionTypes.SETPROJECTSTATUSLIST:
            return {
                ...state,
                projectStatusList: action.payload.list,
            };
        case actionTypes.SETUSERLIST:
            return {
                ...state,
                userList: action.payload.list,
            };
        case actionTypes.SETPROJECTLIST:
            return {
                ...state,
                projectList: action.payload.list,
            };
        case actionTypes.SETPROJECTFILTERLIST:
            return {
                ...state,
                projectFilterList: action.payload.list,
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                projectDetail: null
            };
        case actionTypes.SETPROJECTDETAIL:
            return {
                ...state,
                projectDetail: action.payload.list
            };
        case actionTypes.SETNEWPROJECTDETAILS:
            return {
                ...state,
                newProjectDetails: action.payload
            };
        case actionTypes.SETPROJECTSBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        default:
            return state;
    }
};

export default SDProjectsReducer;